export default __webpack_public_path__ + "static/web1-f1636b16985306e66f3343b6ab8fad2e.png";